import type { Bet, BetslipView } from '@nsftx/seven-client-sdk-integrator'
import type { BetslipEventNames } from '#src/composables/betslipNotificationEvents/types'
import type { ClientTicketActions } from '#src/stores/tickets/types'

const getBetType = (bet: Bet) => {
  if (bet.selections.length === 1 && bet.selectedSystems[0] === 1) {
    return 'Single'
  }

  if (bet.selections.length > 1 && bet.selectedSystems[0] === bet.selections.length) {
    return 'Combo'
  }

  return 'System'
}

const getBetDetails = (bet: Bet) => {
  return {
    type: getBetType(bet),
    status: bet.status.resolutionStatus,
    payment: bet.payin.total,
    stake: bet.payin.stake,
    payinTax: bet.payin.taxes?.reduce((sum, item) => sum + parseFloat(item.value), 0),
    winnings: bet.winnings?.win,
    possiblePayout: bet.pWinnings.max.total,
    payout: bet.winnings?.total,
    payoutTax: bet.winnings?.taxes?.reduce((sum, item) => sum + parseFloat(item.value), 0),
    isStatusOpen: bet.status.resolutionStatus === 'OPEN',
    isStatusWon: bet.status.resolutionStatus === 'WON'
  }
}

const getBetslipActionByNotificationEvent = (event: BetslipEventNames): ClientTicketActions => {
  switch (event) {
    case 'CONFIRM_PLACE_BETSLIP_FINISHED':
      return 'add'
  }
}

const getBetslipLogDetails = (betslip: BetslipView) => ({
  ticket_code: betslip.id,
  product_displayid: betslip.context.linkCode,
  feBetslipId: betslip.context.feBetslipId
})

const getBetslipPayment = (bets: Bet[]) =>
  bets.reduce((sum, bet) => sum + parseFloat(bet.payin.total), 0)

const getBetslipPayinTotal = (betslip: BetslipView) => getBetslipPayment(betslip.bets)

const getBetPayoutAmount = (bet: Bet): number => {
  const { payout } = getBetDetails(bet)
  const candidates = [payout, bet.winnings?.total, bet.winnings?.win]

  for (const candidate of candidates) {
    const parsed = Number.parseFloat(String(candidate ?? ''))

    if (Number.isFinite(parsed) && parsed > 0) {
      return parsed
    }
  }

  return 0
}

const getBetslipBarcode = (betslip: BetslipView) =>
  betslip.codes.find((code) => code.type === 'BARCODE')?.id ?? null

export {
  getBetDetails,
  getBetPayoutAmount,
  getBetslipActionByNotificationEvent,
  getBetslipLogDetails,
  getBetslipPayment,
  getBetslipPayinTotal,
  getBetslipBarcode
}
